// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateAssociationBinding, CreateAssociationBindingSchema } from 'api/gen/CreateAssociationBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateAssociationBindingAdminBaseObject, ValidateAssociationBindingAdminBaseObjectSchema } from 'api/gen/ValidateAssociationBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateAssociationBindingAdmin'),
  binding: t.union([CreateAssociationBindingSchema, t.null]),
});

export const ValidateCreateAssociationBindingAdminSchema = excess(t.intersection([ValidateAssociationBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateAssociationBindingAdmin extends t.TypeOf<typeof ValidateCreateAssociationBindingAdminSchema> {}
